<script setup lang="ts">
  import type { CorrectedWord, FillLogsFieldEntry, FillLogsPaperTarget } from '../model/fill-logs-text';
  import FillLogsBeforeLine from './FillLogsBeforeLine.vue';
  import FillLogsValueText from './FillLogsValueText.vue';
  import { READING_BUTTON, TONE_BAR, TONE_TINT, toneSaid } from './fill-logs-tone';

  defineProps<{ entries: FillLogsFieldEntry[]; correctedWord: CorrectedWord }>();
  const emit = defineEmits<{ (e: 'show', target: FillLogsPaperTarget): void }>();
</script>

<template>
  <ul class="grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] gap-x-4 gap-y-2">
    <li
      v-for="entry in entries"
      :key="entry.key"
      class="min-w-0"
      :class="{ 'col-span-full': entry.wide }"
    >
      <button
        type="button"
        class="flex h-full min-w-0 flex-col gap-0.5 rounded-sm border-l-[3px] px-2.5 py-1.5"
        :class="[READING_BUTTON, entry.tone ? [TONE_BAR[entry.tone], TONE_TINT[entry.tone]] : 'border-l-transparent']"
        :data-key="entry.key"
        :data-tone="entry.tone ?? undefined"
        data-testid="fill-logs-all-field"
        @click="emit('show', { targets: [entry.key], tone: entry.tone, label: entry.label })"
      >
        <span
          class="text-xs/4 font-semibold text-gray-03 [overflow-wrap:anywhere]"
          data-testid="fill-logs-all-label"
        >
          {{ entry.label }}<span
            v-if="entry.tone"
            class="sr-only"
          >, {{ toneSaid(entry.tone, correctedWord) }}</span>
        </span>
        <span class="block max-w-[70ch] text-sm/5 text-gray-07">
          <FillLogsValueText :value="entry.value" />
          <FillLogsBeforeLine
            v-if="entry.before"
            :before="entry.before"
          />
        </span>
        <span class="sr-only">. Ver no registro.</span>
      </button>
    </li>
  </ul>
</template>
